import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Atlanta — over 3.5 hours from Savannah",
      "NPIC appointment required before driving to Atlanta",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Atlanta needed",
      "Ideal for SAV international flyers",
      "Perfect for SCAD students studying abroad",
      "Great for Gulfstream Aerospace business travelers",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Chatham County post offices",
      "Good for planned international trips from SAV",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Chatham County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function SavannahProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Savannah"
      headingExtra="GA"
      introText="Savannah and coastal Georgia travelers — SAV international flyers, SCAD students studying abroad, Gulfstream Aerospace business travelers, Port of Savannah workers, and Historic District families — have several options for getting a passport fast. Here is how they compare, and why most coastal Georgia residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 3.5-hour drive to Atlanta."
      options={options}
      emergencyDescription="Savannah does not have its own regional passport agency. The closest agency is in Atlanta — over a 3.5-hour drive each way via I-16 and I-75. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at the Atlanta Passport Agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Savannah does not have a regional passport agency — the closest is Atlanta, roughly 3.5 hours away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}